import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Listing states
  caseListing: {
    loading: false,
    error: null,
    data: null,
  },
  caseDetails: {
    loading: false,
    error: null,
    data: null,
  },
  activeCases: {
    loading: false,
    error: null,
    data: null,
  },
  dashboard: {
    loading: false,
    error: null,
    data: null,
  },
  myInquiries: {
    loading: false,
    error: null,
    data: null,
  },

  // Mutation states
  triggerCase: {
    loading: false,
    error: null,
    data: null,
  },
  updateCase: {
    loading: false,
    error: null,
    data: null,
  },
  respondInquiry: {
    loading: false,
    error: null,
    data: null,
  },
  updateDelivery: {
    loading: false,
    error: null,
    data: null,
  },

  // Campus/Location states
  campusListing: {
    loading: false,
    error: null,
    data: null,
  },
  locationListing: {
    loading: false,
    error: null,
    data: null,
  },
  campusMutation: {
    loading: false,
    error: null,
    data: null,
  },
  locationMutation: {
    loading: false,
    error: null,
    data: null,
  },
};

const redistributionSlice = createSlice({
  name: "redistribution",
  initialState,
  reducers: {
    // Case Listing
    caseListingStart: (state) => {
      state.caseListing.loading = true;
      state.caseListing.error = null;
    },
    caseListingSuccess: (state, action) => {
      state.caseListing.loading = false;
      state.caseListing.data = action.payload;
      state.caseListing.error = null;
    },
    caseListingFailure: (state, action) => {
      state.caseListing.loading = false;
      state.caseListing.error = action.payload;
    },
    caseListingReset: (state) => {
      state.caseListing = initialState.caseListing;
    },

    // Case Details
    caseDetailsStart: (state) => {
      state.caseDetails.loading = true;
      state.caseDetails.error = null;
    },
    caseDetailsSuccess: (state, action) => {
      state.caseDetails.loading = false;
      state.caseDetails.data = action.payload;
      state.caseDetails.error = null;
    },
    caseDetailsFailure: (state, action) => {
      state.caseDetails.loading = false;
      state.caseDetails.error = action.payload;
    },
    caseDetailsReset: (state) => {
      state.caseDetails = initialState.caseDetails;
    },

    // Active Cases
    activeCasesStart: (state) => {
      state.activeCases.loading = true;
      state.activeCases.error = null;
    },
    activeCasesSuccess: (state, action) => {
      state.activeCases.loading = false;
      state.activeCases.data = action.payload;
      state.activeCases.error = null;
    },
    activeCasesFailure: (state, action) => {
      state.activeCases.loading = false;
      state.activeCases.error = action.payload;
    },

    // Dashboard
    dashboardStart: (state) => {
      state.dashboard.loading = true;
      state.dashboard.error = null;
    },
    dashboardSuccess: (state, action) => {
      state.dashboard.loading = false;
      state.dashboard.data = action.payload;
      state.dashboard.error = null;
    },
    dashboardFailure: (state, action) => {
      state.dashboard.loading = false;
      state.dashboard.error = action.payload;
    },

    // My Inquiries (HeaterSM)
    myInquiriesStart: (state) => {
      state.myInquiries.loading = true;
      state.myInquiries.error = null;
    },
    myInquiriesSuccess: (state, action) => {
      state.myInquiries.loading = false;
      state.myInquiries.data = action.payload;
      state.myInquiries.error = null;
    },
    myInquiriesFailure: (state, action) => {
      state.myInquiries.loading = false;
      state.myInquiries.error = action.payload;
    },

    // Trigger Case
    triggerCaseStart: (state) => {
      state.triggerCase.loading = true;
      state.triggerCase.error = null;
      state.triggerCase.data = null;
    },
    triggerCaseSuccess: (state, action) => {
      state.triggerCase.loading = false;
      state.triggerCase.data = action.payload;
      state.triggerCase.error = null;
    },
    triggerCaseFailure: (state, action) => {
      state.triggerCase.loading = false;
      state.triggerCase.error = action.payload;
    },
    triggerCaseReset: (state) => {
      state.triggerCase = initialState.triggerCase;
    },

    // Update Case (acknowledge, verify, allocate, close, cancel, etc.)
    updateCaseStart: (state) => {
      state.updateCase.loading = true;
      state.updateCase.error = null;
      state.updateCase.data = null;
    },
    updateCaseSuccess: (state, action) => {
      state.updateCase.loading = false;
      state.updateCase.data = action.payload;
      state.updateCase.error = null;
    },
    updateCaseFailure: (state, action) => {
      state.updateCase.loading = false;
      state.updateCase.error = action.payload;
    },
    updateCaseReset: (state) => {
      state.updateCase = initialState.updateCase;
    },

    // Respond to Inquiry
    respondInquiryStart: (state) => {
      state.respondInquiry.loading = true;
      state.respondInquiry.error = null;
      state.respondInquiry.data = null;
    },
    respondInquirySuccess: (state, action) => {
      state.respondInquiry.loading = false;
      state.respondInquiry.data = action.payload;
      state.respondInquiry.error = null;
    },
    respondInquiryFailure: (state, action) => {
      state.respondInquiry.loading = false;
      state.respondInquiry.error = action.payload;
    },
    respondInquiryReset: (state) => {
      state.respondInquiry = initialState.respondInquiry;
    },

    // Update Delivery
    updateDeliveryStart: (state) => {
      state.updateDelivery.loading = true;
      state.updateDelivery.error = null;
      state.updateDelivery.data = null;
    },
    updateDeliverySuccess: (state, action) => {
      state.updateDelivery.loading = false;
      state.updateDelivery.data = action.payload;
      state.updateDelivery.error = null;
    },
    updateDeliveryFailure: (state, action) => {
      state.updateDelivery.loading = false;
      state.updateDelivery.error = action.payload;
    },
    updateDeliveryReset: (state) => {
      state.updateDelivery = initialState.updateDelivery;
    },

    // Campus Listing
    campusListingStart: (state) => {
      state.campusListing.loading = true;
      state.campusListing.error = null;
    },
    campusListingSuccess: (state, action) => {
      state.campusListing.loading = false;
      state.campusListing.data = action.payload;
      state.campusListing.error = null;
    },
    campusListingFailure: (state, action) => {
      state.campusListing.loading = false;
      state.campusListing.error = action.payload;
    },

    // Location Listing
    locationListingStart: (state) => {
      state.locationListing.loading = true;
      state.locationListing.error = null;
    },
    locationListingSuccess: (state, action) => {
      state.locationListing.loading = false;
      state.locationListing.data = action.payload;
      state.locationListing.error = null;
    },
    locationListingFailure: (state, action) => {
      state.locationListing.loading = false;
      state.locationListing.error = action.payload;
    },

    // Campus Mutation (create/update/delete)
    campusMutationStart: (state) => {
      state.campusMutation.loading = true;
      state.campusMutation.error = null;
      state.campusMutation.data = null;
    },
    campusMutationSuccess: (state, action) => {
      state.campusMutation.loading = false;
      state.campusMutation.data = action.payload;
      state.campusMutation.error = null;
    },
    campusMutationFailure: (state, action) => {
      state.campusMutation.loading = false;
      state.campusMutation.error = action.payload;
    },
    campusMutationReset: (state) => {
      state.campusMutation = initialState.campusMutation;
    },

    // Location Mutation (create/update/delete)
    locationMutationStart: (state) => {
      state.locationMutation.loading = true;
      state.locationMutation.error = null;
      state.locationMutation.data = null;
    },
    locationMutationSuccess: (state, action) => {
      state.locationMutation.loading = false;
      state.locationMutation.data = action.payload;
      state.locationMutation.error = null;
    },
    locationMutationFailure: (state, action) => {
      state.locationMutation.loading = false;
      state.locationMutation.error = action.payload;
    },
    locationMutationReset: (state) => {
      state.locationMutation = initialState.locationMutation;
    },
  },
});

export const {
  // Case Listing
  caseListingStart,
  caseListingSuccess,
  caseListingFailure,
  caseListingReset,
  // Case Details
  caseDetailsStart,
  caseDetailsSuccess,
  caseDetailsFailure,
  caseDetailsReset,
  // Active Cases
  activeCasesStart,
  activeCasesSuccess,
  activeCasesFailure,
  // Dashboard
  dashboardStart,
  dashboardSuccess,
  dashboardFailure,
  // My Inquiries
  myInquiriesStart,
  myInquiriesSuccess,
  myInquiriesFailure,
  // Trigger Case
  triggerCaseStart,
  triggerCaseSuccess,
  triggerCaseFailure,
  triggerCaseReset,
  // Update Case
  updateCaseStart,
  updateCaseSuccess,
  updateCaseFailure,
  updateCaseReset,
  // Respond Inquiry
  respondInquiryStart,
  respondInquirySuccess,
  respondInquiryFailure,
  respondInquiryReset,
  // Update Delivery
  updateDeliveryStart,
  updateDeliverySuccess,
  updateDeliveryFailure,
  updateDeliveryReset,
  // Campus Listing
  campusListingStart,
  campusListingSuccess,
  campusListingFailure,
  // Location Listing
  locationListingStart,
  locationListingSuccess,
  locationListingFailure,
  // Campus Mutation
  campusMutationStart,
  campusMutationSuccess,
  campusMutationFailure,
  campusMutationReset,
  // Location Mutation
  locationMutationStart,
  locationMutationSuccess,
  locationMutationFailure,
  locationMutationReset,
} = redistributionSlice.actions;

export default redistributionSlice.reducer;
